import {VesselCall} from "~/queries";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {ErrorOutline} from "@mui/icons-material";


export type VesselCallMapProps = {
    vesselCall: VesselCall
}


export const VesselCallMap = (props: VesselCallMapProps) => {
    const {vesselCall} = props;
    const src: URL = new URL("https://www.vesselfinder.com/aismap");
    const params = {
        width: "100%",
        height: "100%",
        names: true,
        imo: vesselCall.vessel?.imo,
        track: true,
        fleet_name: false,
        fleet_hide_old_positions: false,
        clicktoact: false,
        store_pos: true,
    }
    Object.entries(params).forEach(([key, value]) => {
        src.searchParams.set(key, String(value));
    });

    if (!vesselCall.vessel?.imo) {
        return (
            <ErrorBlock icon={<ErrorOutline style={{fontSize: "30px"}}/>} title="Нет данных">
                Отсутствует IMO судна для отображения карты
            </ErrorBlock>
        );
    }

    return (
        <iframe
            name="vesselfinder"
            id="vesselfinder"
            width="100%"
            height="100%"
            src={src.toString()}
        />
    )
}